import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Button,
    Typography,
    Avatar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tooltip,
    Chip,
    Stack,
    InputAdornment,
    TablePagination,
    Autocomplete,
    Menu,
    MenuItem
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import "../../styles/global.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {  GetAllSchool } from "../../api/auth/authService";

import { GetAllGroup,PostGroup } from "../../api/auth/authService";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "../../components/SnackBar/SnackbarContext";
import * as Yup from 'yup';
import configAPI from "../../api/config";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
const GroupList = () => {
    const today = dayjs();
    const { showSnackbar } = useSnackbar();
    const user = useSelector((state) => state.auth?.user);
    const BASE_URL = configAPI.REACT_APP_API_BASE_URL;
    const [roleName, setRoleName] = useState("");
    const [totalCount, setTotalCount] = useState(1);
    const [groups, setGroups] = useState([]);
const [loading, setLoading] = useState(false);
const groupValidationSchema = Yup.object().shape({
    GroupName: Yup.string()
        .trim()
        .required("Group Name is required"),
});
    const validationSchema = Yup.object().shape({
        FirstName: Yup.string().required("First Name is required"),
        LastName: Yup.string().required("Last Name is required"),
        Email: Yup.string()
            .email("Invalid email format")
            .required("Email is required"),
        PhoneNumber: Yup.string()
            .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
            .required("Phone number is required"),
        Password: Yup.string()
            .when('isEditMode', {
                is: false,
                then: (schema) => schema
                    .required("Password is required")
                    .min(8, "Password must be at least 8 characters long")
                    .max(50, "Password cannot exceed 50 characters")
                    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
                    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
                    .matches(/[0-9]/, "Password must contain at least one number")
                    .matches(/[^a-zA-Z0-9]/, "Add Special characters."),
                otherwise: (schema) => schema
                    .optional()
                    .nullable()
            }),
        RoleID: Yup.string()
            .uuid("Role ID must be a valid UUID")
            .required("Role ID is required"),
        ExpiryDate: Yup.date()
            .nullable()
            .required("Expiry Date is required")
            .typeError("Invalid date"),
        SchoolID: Yup.string()
            .uuid("School ID must be a valid UUID")
            .required("School is required"),
        ProfileImage: Yup.mixed()
            .required("Profile image is required")
            .test(
                "file",
                "Profile image is required",
                (value) => value !== null && value !== undefined
            ),
    });
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [formData, setFormData] = useState({
   
        GroupName:"",
    });

    const [openModal, setOpenModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [viewAdmin, setViewAdmin] = useState(null);
    const [editingAdminId, setEditingAdminId] = useState(null);
 
    const [errors, setErrors] = useState({});
  
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const location = useLocation();
    const [loadingSchools, setLoadingSchools] = useState(true);
    const SchoolForAdmin = location.state?.school;
    const [schools, setSchools] = useState([]);
  
    useEffect(() => {
        if (user) {
            setFormData(prev => ({
                ...prev,
                RoleID: user.roleID || ""
            }));
            setRoleName(user.roleName || "Admin");
        }
        if (SchoolForAdmin) {
            setFormData(prev => ({
                ...prev,
                SchoolID: SchoolForAdmin.id || "",
                Email: SchoolForAdmin.ContactEmail || "",
                PhoneNumber: SchoolForAdmin.ContactPhone || "",
                ExpiryDate: SchoolForAdmin.LicenceEndDate
                    ? dayjs(SchoolForAdmin.LicenceEndDate)
                    : SchoolForAdmin.AcademicYearEnd
                        ? dayjs(SchoolForAdmin.AcademicYearEnd)
                        : null
            }));
            setOpenModal(true);
            setIsEditMode(false);
        }
    }, [SchoolForAdmin]);
    useEffect(() => {
        if (user) {
            setRoleName(user.roleName || "Admin");
            setFormData(prev => ({
                ...prev,
                RoleID: user.roleID || ""
            }));
        }
    }, [user]);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const schoolOptions = SchoolForAdmin ? { id: SchoolForAdmin.id, label: SchoolForAdmin.SchoolName } : null;
   const fetchGroups = async () => {
    try {
        setLoading(true);
        const response = await GetAllGroup("");

        if (response?.success) {
            setGroups(response.data?.data || response.data || []);
            setTotalCount(response.data?.data?.length || response.data?.length || 0);
        } else {
            setGroups([]);
        }
    } catch (error) {
        console.error(error);
        showSnackbar("Failed to load groups", "error");
    } finally {
        setLoading(false);
    }
};
useEffect(() => {
    fetchGroups();
}, []);

    useEffect(() => {
    const fetchSchools = async () => {
        try {
            setLoadingSchools(true);

            const response = await GetAllSchool("");

            if (response?.success) {
                setSchools(response.data || []);
            } else {
                setSchools([]);
            }
        } catch (error) {
            console.error(error);
            setSchools([]);
            showSnackbar("Failed to load schools", "error");
        } finally {
            setLoadingSchools(false);
        }
    };

    fetchSchools();
}, []);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: undefined }));
        }
    };


    const handleAddAdminClick = () => {
        resetForm();
        if (user) {
            setFormData(prev => ({
                ...prev,
                RoleID: user.roleID || ""
            }));
        }
        setIsEditMode(false);
        setEditingAdminId(null);
        setOpenModal(true);
        navigate(location.pathname, { replace: true, state: {} });
    };

   
 
const handleSubmit = async () => {
    try {
       
 await groupValidationSchema.validate(formData, { abortEarly: false });
        setErrors({});
        setLoading(true);

        const payload = new FormData();
        payload.append("GroupId", formData.GroupId || "");
        payload.append("GroupName", formData.GroupName);
        payload.append("GroupCode", formData.GroupCode || "");

        const response = await PostGroup(payload);

        if (response?.success) {
            showSnackbar(response.message || "Group created successfully", "success");
             await fetchGroups(); 
            handleCloseModal();
            
        } else {
            showSnackbar(response?.message || "Failed to create group", "error");
        }

    } catch (err) {
        if (err.name === "ValidationError") {
            const newErrors = {};
            err.inner.forEach((e) => {
                newErrors[e.path] = e.message;
            });
            setErrors(newErrors);
        } else {
            console.error(err);
        }
    } finally {
        setLoading(false);
    }
};

 

    const handleCloseModal = () => {
        setOpenModal(false);
        resetForm();
        setIsEditMode(false);
        setEditingAdminId(null);
        navigate(location.pathname, { replace: true, state: {} });
    };

    const resetForm = () => {
        setFormData({
            FirstName: "",
            LastName: "",
            SchoolID: "",
            Email: "",
            PhoneNumber: "",
            Password: "",
            RoleID: "",
            ExpiryDate: null,
            ProfileImage: null,
            ProfilePreview: null
        });
        setErrors({});
    };

const schoolByGroupId = React.useMemo(() => {
    const map = {};
    schools.forEach((school) => {
        if (!school.groupId) return;

        if (!map[school.groupId]) {
            map[school.groupId] = [];
        }

        map[school.groupId].push(school.schoolName);
    });
    return map;
}, [schools]);

const filteredGroups = groups.filter((group) => {
    const groupName = group.groupName || "";
    const schoolName =
        schoolByGroupId[group.groupId] || "";

    const search = searchTerm.toLowerCase();

    return (
        groupName.includes(search) ||
        schoolName.includes(search)
    );
});
    return (
        <Box p={0}>
            <Box sx={{
                background: "#fff",
                borderRadius: 2,
                pt: 3,
                px: 3,
                pb: 1,
            }}>
                {/* <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: 2,
                        mb: 2,
                        borderRadius: "8px",
                        background: "linear-gradient(135deg, #f5f9ff, #eef3ff)",
                        border: "1px solid #e0e7ff",
                    }}
                >
                    <Box>
                        <Typography
                            variant="h6"
                            fontWeight={700}
                            sx={{ color: "#1e3a8a", lineHeight: 1.2 }}
                        >
                            Add Group
                        </Typography>

                        <Typography
                            variant="caption"
                            sx={{ color: "#64748b" }}
                        >
                            Manage all Group
                        </Typography>
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <TextField
                                fullWidth
                                placeholder="Search group name"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                size="small"
                            />
                        </Grid>
                    </Box>

                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleAddAdminClick}
                        sx={{ boxShadow: "none", '&:hover': { boxShadow: "none" } }}
                    >
                      Create Group
                    </Button>
                </Box> */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "stretch", sm: "center" },
                        gap: 2,
                        p: 2,
                        mb: 2,
                        borderRadius: "8px",
                        background: "linear-gradient(135deg, #f5f9ff, #eef3ff)",
                        border: "1px solid #e0e7ff",
                    }}
                >
                    <Box >
                        <Typography
                            variant="h6"
                            fontWeight={700}
                            sx={{ color: "#1e3a8a", lineHeight: 1.2 }}
                        >
                            Add Group
                        </Typography>

                        <Typography variant="caption" sx={{ color: "#64748b" }}>
                            Manage all Group
                        </Typography>

                        <Box sx={{ mt: 1 }}>
                            <TextField
                                fullWidth
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                size="small"
                            />
                        </Box>
                    </Box>

                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleAddAdminClick}
                        sx={{
                            alignSelf: { xs: "stretch", sm: "center", },
                            "&:hover": { boxShadow: "none" },
                        }}
                    >
                        Create Group
                    </Button>
                </Box>
                {totalCount === 0 ? (
                    <Box
                        sx={{
                            textAlign: 'center',
                            py: 8,
                            border: '2px dashed #e0e0e0',
                            borderRadius: 2
                        }}
                    >
                        <Typography color="textSecondary" variant="h6" gutterBottom>
                            No Group Found
                        </Typography>
                        <Typography color="textSecondary" variant="body1" paragraph>
                            Click on "Add New Group" button to Add your first Group
                        </Typography>
                    </Box>
                ) : (
                    <TableContainer sx={{ boxShadow: 'none', border: '1px solid #d7d0d0ff',maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>S.No.</strong></TableCell>
                                    <TableCell sx={{ padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>Group Name</strong></TableCell>
                                    <TableCell sx={{minWidth:120,padding: '8px',backgroundColor: '#f5f5f5', fontSize: '13px'}}><strong>SchoolName</strong></TableCell>
                                  
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredGroups
                                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((group, index) => (
                                        <TableRow key={group.groupId} hover>
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>
                                                {page * rowsPerPage + index + 1}
                                            </TableCell>
                                            
                                            <TableCell sx={{ padding: '8px', fontSize: '13px' }}>{group.groupName || "N/A"}</TableCell>
    <TableCell sx={{ padding: '8px', fontSize: '13px' }}>
   
     {schoolByGroupId[group.groupId]?.join(", ") || "N/A"}
</TableCell>


                                          
                                        </TableRow>
                                        
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                />
            </Box>
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                maxWidth="md"
                // fullWidth
                width="500px"
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'primary.main',
                    color: 'white',
                    
                }}>
                    <Typography variant="h6">
                        {isEditMode ? 'Edit Group' : 'Add New Group'}
                    </Typography>
                    <IconButton onClick={handleCloseModal} sx={{ color: 'white' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers sx={{ pt: 3 }}>
                    <Box component="form" noValidate>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12}}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    label="Group Name"
                    name="GroupName"
                    value={formData.GroupName}
                    onChange={handleChange}
                     required
                                    variant="filled"
                                    error={!!errors.GroupName}
                                    // helperText={errors.GroupName}
                                    className={`cp-form-control input-focus ${errors.GroupName ? "error" : ""}`}
                                    
                                    // error={!!errors.FirstName}
                                    // helperText={errors.FirstName}
                                    // onInput={(e) => {
                                    //     e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                                    // }}
                                    inputProps={{
                                        inputMode: "text",
                                    }}
                                />
                            </Grid>

                        </Grid>
                    </Box>

                </DialogContent>
    
                <DialogActions sx={{ p: 2 }}>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        sx={{
                            boxShadow: "none",
                            '&:hover': {
                                boxShadow: "none"
                            }
                        }}
                    >
                       Save {/* {isEditMode ? 'Update Admin' : 'Register Admin'} */}
                    </Button>
                </DialogActions>
            </Dialog>

          

            
        </Box>
    );
};

export default GroupList;